<template>
<div class="excursion">
    <div class="excursion__element" v-for="({daystops, dayrec: {start,nday}}) in props.timetable" :key="nday">
        <div class="excursion__header" @click.stop="day_click(nday)">
            <div class="excursion__title">День {{nday}}</div>
            <div class="excursion__date">{{start.locale('ru').format('D MMMM YYYY, dddd')}}</div>
            <vDown class="vicon-white excursion__expand" :class="{ _open: opened_has(nday) }"  />
        </div>
        <template v-if="opened_has(nday)">
            <div class="excursion__content">

                <div class="excursion__point" v-for="day in daystops" :key="day.id">
                    <div class="excursion__brief">
                        <div class="excursion__brief-title">{{day.place}}</div>
                        <div class="excursion__brief-section">
                            <div v-if="day.hasArrival" class="excursion__brief-element">
                                <div class="excursion__brief-label">Прибытие</div>
                                <div class="excursion__brief-value">{{arrival(day,nday)}}</div>
                            </div>
                            <div v-if="day.hasArrival && day.hasDeparture" class="excursion__brief-element">
                                <div class="excursion__brief-label">Стоянка</div>
                                <div class="excursion__brief-value">{{diff(day,nday)}}</div>
                            </div>
                            <div v-if="day.hasDeparture" class="excursion__brief-element">
                                <div class="excursion__brief-label">Отправление</div>
                                <div class="excursion__brief-value">{{departure(day,nday)}}</div>
                            </div>
                        </div>

                    </div>
                    
                    <InsertHtml class="excursion__more" :html="day.description" link="pdf" />

                    <MySliderExcursion v-if="day.excursions" class="excursion__slider" :excursion="day.excursions" />
                </div>

            </div>
        </template>

    </div>
</div>
</template>

<style lang="scss" src="./TimetableInf.scss"></style>

<script setup>
import {onMounted, ref, unref} from 'vue'
import MySliderExcursion from '@/comp/MySlider/MySliderExcursion.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import duration from 'dayjs/plugin/duration'
import vDown from '@/assets/vicons/chevron-down.vue'
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'

dayjs.extend(duration)

const props = defineProps({
  timetable: Array,
})

const opened = ref( {} )

onMounted(()=>{
    opened.value = Object.fromEntries(
        props.timetable.map( ( {dayrec:{nday}} ) => [nday, false] )
    )
})

const opened_has = nday => unref(opened)[nday] ? true : false

const day_click = nday => {
    let has = opened_has(nday)
    opened.value[nday] = !has
}

const arrival = (day, nday) =>  !day.hideTime ? 
    dayjs(day.dateArrival).locale('ru').format('HH:mm') 
    : '--:--'

const departure = (day, nday) =>  !day.hideTime ? 
    dayjs(day.dateDeparture).locale('ru').format('HH:mm') 
    : '--:--'
    
const diff = (day, nday) => {
    let ret = '-- ч -- мин'
    if (!day.hideTime) {
        const start = dayjs(day.dateArrival)
        const end = dayjs(day.dateDeparture)
        const diffMs = end.diff(start)
        const dur = dayjs.duration(diffMs)
        const days = Math.floor(dur.asDays())
        const hours = dur.hours()
        const minutes = dur.minutes()
        let a = []
        days && a.push(`${days} д`)
        hours && a.push(`${hours} ч`)
        minutes && a.push(`${minutes} мин`)

        ret = a.join(' ')
    }
    return ret
}

</script>